/**
 * Returns the name of the vehicleCategory for the given axleCount.
 * @param {number} axleCount
 * @returns {string}
 */
export function getVehicleCategory(axleCount: number): string {
  return 'J' + (axleCount < 5 ? axleCount : 5);
}
